import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { Card } from "@mui/material";
import FileUploader from "../../FileUploader";
import { endpoints } from "../../../services/apiurl";
import Input from "../../UI/Input/Input";
import PageTitle from "../../UI/PageTitle";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddMedia = () => {
  let history = useHistory();
  const [cat, setCat] = useState({
    media_type: "",
    status: "",
    restro_id: "",
    video_link: "",
    category: "",
    image_type: "",
    position: "",
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const handleFileSelectSuccess = (file) => {
    setSelectedFile(file);
  };

  const handleFileSelectError = ({ error }) => {
    alert(error);
  };
  const [loading, setloading] = useState(false);
  const [rest, setRest] = useState([]);

  const {
    media_type,
    video_link,
    status,
    restro_id,
    category,
    image_type,
    position,
  } = cat;
  const onInputChange = (e) => {
    setCat({ ...cat, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    getRestaurentsDropDown();
  }, []);

  const getRestaurentsDropDown = async () => {
    await axios.post(endpoints.getRestaurentsDropDown).then((response) => {
      setRest(response.data.data);
    });
  };

  const onSubmit = async (e) => {
    setloading(true);
    e.preventDefault();
    if (media_type == 1) {
      if (!selectedFile) {
        alert("Please select image");
        setloading(false);
        return false;
      }
    }

    const formData = new FormData();
    formData.append("video_link", video_link);
    formData.append("media_type", media_type);
    formData.append("restro_id", restro_id);
    formData.append("media", selectedFile);
    formData.append("status", status);
    formData.append("category", category);
    formData.append("image_type", image_type);
    formData.append("position", position);
    try {
      const response = await axios.post(
        endpoints.addRestaurentsMedia,
        formData
      );
      setloading(false);
      history.goBack();
      if (response.data && response.data.status === true) {
        toast.success("Gallery Image Added Successfully!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        // Handle other cases if needed
      }
    } catch (error) {
      console.error("Error during adding Gallery Image:", error);
      setloading(false);

      toast.error("Error during adding Gallery Image. Please try again.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };
  return (
    <div className="ui main">
      <PageTitle title="Add Gallery" linkurl="" linkTitle="" />

      <Card className="px-3 py-3">
        <form
          className="ui form"
          onSubmit={(e) => onSubmit(e)}
          encType="multipart/form-data"
        >
          <div className="row">
            <div className="col col-6">
              <label>Restaurents </label>
              <select
                name="restro_id"
                required
                className="form-control"
                onChange={(e) => onInputChange(e)}
              >
                <option value="">Select Restaurents</option>
                {rest.map((e, key) => {
                  return (
                    <option key={key} value={e.id}>
                      {e.name}
                    </option>
                  );
                })}
              </select>
            </div>

            {/* <Input id="name" label="Name" type="text" name="name" place="Name" onChange={(e) => onInputChange(e)}
                            requiredInput="required" value={name} class="col col-6"
                        /> */}

            <div className="col col-6">
              <label>Media Type</label>
              <select
                name="media_type"
                required
                className="form-control"
                onChange={(e) => onInputChange(e)}
              >
                <option value="">Select Media Type</option>
                <option value="1">Image</option>
                <option value="2">Video</option>
              </select>
            </div>
            <div className="col col-6">
              <label>Category</label>
              <select
                name="category"
                required
                className="form-control"
                onChange={(e) => onInputChange(e)}
              >
                <option value="">Select Category</option>
                <option value="food">Food</option>
                <option value="drink">Drink</option>
                <option value="ambiance">Ambience</option>
              </select>
            </div>

            <div className="col col-6">
              <label>Image Type</label>
              <select
                name="image_type"
                required
                className="form-control"
                onChange={(e) => onInputChange(e)}
              >
                <option value="">Select </option>
                <option value="banner">Banner</option>
                <option value="gallery">Gallery</option>
              </select>
            </div>
          </div>

          <div className="row">
            {media_type == 2 ? (
              <>
                <Input
                  id="video link"
                  label="Video Link"
                  type="text"
                  name="video_link"
                  place="Video Link"
                  onChange={(e) => onInputChange(e)}
                  requiredInput="required"
                  value={video_link}
                  class="col col-6"
                />
                <div className="col col-6">
                  <label>Image</label>
                  <FileUploader
                    onFileSelectSuccess={(file) => setSelectedFile(file)}
                    onFileSelectError={({ error }) => alert(error)}
                  />
                </div>
              </>
            ) : media_type == 1 ? (
              <div className="col col-6">
                <label>Image</label>

                <FileUploader
                  onFileSelectSuccess={(file) => setSelectedFile(file)}
                  onFileSelectError={({ error }) => alert(error)}
                />
                {selectedFile && (
                  <div>
                    <img
                      src={URL.createObjectURL(selectedFile)}
                      alt="Selected Logo"
                      className="mt-3"
                      height="200px"
                      width="200px"
                    />
                  </div>
                )}
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="row">
            {image_type === "banner" ? (
              <>
                <Input
                  id="position"
                  label="Banner Position"
                  type="number"
                  name="position"
                  place="Banner Position"
                  onChange={(e) => onInputChange(e)}
                  requiredInput="required"
                  value={position}
                  class="col col-6"
                />{" "}
              </>
            ) : (
              ""
            )}
          </div>

          <div className="row">
            <div className="col col-6">
              <div className="mt-3">
                <LoadingButton
                  type="submit"
                  loading={loading}
                  loadingPosition="start"
                  startIcon={<SaveIcon />}
                  variant="contained"
                  size="large"
                >
                  Save
                </LoadingButton>
                <ToastContainer />
              </div>
            </div>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default AddMedia;
